const IOType = {
    SIMPLE_MEDIUM_LINEAR_MOTOR: 0x01,
    TRAIN_MOTOR: 0x02,
    BUTTION: 0x05,
    LIGHT: 0x08,
    VOLTAGE: 0x14,
    CURRENT: 0x15,
    PIEZO_TONE: 0x16,
    RGB_LIGHT: 0x17,
    TILT_SENSOR: 0x22,
    MOTION_SENSOR: 0x23,
    COLOR_DISTANCE_SENSOR: 0x25,
    MEDIUM_LINEAR_MOTOR: 0x26,
    MOVE_HUB_MOTOR: 0x27,
    MOVE_HUB_TILT_SENSOR: 0x28,
    DUPLO_TRAIN_BASE_MOTOR: 0x29,
    DUPLO_TRAIN_BASE_SPEAKER: 0x2a,
    DUPLO_TRAIN_BASE_COLOR_SENSOR: 0x2b,
    DUPLO_TRAIN_BASE_SPEEDOMETER: 0x2c,
    TECHNIC_LARGE_MOTOR: 0x2e,
    TECHNIC_XL_MOTOR: 0x2f,
    TECHNIC_MEDIUM_ANGULAR_MOTOR: 0x30,
    TECHNIC_LARGE_ANGULAR_MOTOR: 0x31,
    REMOTE_POWER_CONTROL_BUTTON: 0x37,
    TECHNIC_HUB_TILT_SENSOR: 0x3b,
    TECHNIC_COLOR_SENSOR: 0x3d,
    TECHNIC_DISTANCE_SENSOR: 0x3e,
    TECHNIC_FORCE_SENSOR: 0x3f,
    TECHNIC_SMALL_ANGULAR_MOTOR: 0x41,
    MARIO_COLOR_BARCODE_SENSOR: 0x49,
    MARIO_PANTS: 0x4a,
    TECHNIC_MEDIUM_ANGULAR_MOTOR_GRAY: 0x4b,
    TECHNIC_LARGE_ANGULAR_MOTOR_GRAY: 0x4c,
};

module.exports = IOType;
